<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.token_log") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-12.mb-1
                DateRangePicker(:value="dateRange" @update="getData")
              .form-group.col-md-3.col-2.mb-1(v-if="!isOperator")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user-secret
                  DebounceInput(autofocus type="text" v-model="searchOperatorID" :placeholder="$t('ui.operator_id')" @enter="getLogList(true)" size="sm")
              .form-group.col-md-3.col-2.mb-1(v-if="searchOperatorID.length > 0")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user
                  DebounceInput(autofocus type="text" v-model="searchMemberID" :placeholder="$t('ui.member_id')" @enter="getLogList(true)" size="sm")  
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getLogList(true)"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="5%")
                          span #
                        th.text-left(width="11%" @click="sortOrder('account_id')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id')")
                        th.text-right(width="12%")
                          span(:title="$t('ui.balance_before')") {{ $t('ui.balance_before') }}
                        th.text-right(width="12%" @click="sortOrder('amount')")
                          span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                          .float-right
                            i(:class="changeSortKey('amount')")
                        th.text-right(width="12%")
                          span(:title="$t('ui.balance_after')") {{ $t('ui.balance_after') }}
                        th(width="13%")
                          span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
                        th.text-center(width="10%" @click="sortOrder('action_type')")
                          span(:title="$t('ui.action_status')") {{ $t('ui.action_status') }}
                          .float-right
                            i(:class="changeSortKey('action_type')")
                        th.text-center(width="10%")
                          span(:title="$t('ui.cycle')") {{ $t('ui.action_by') }}
                        th.text-right(width="10%" @click="sortOrder('action_date')")
                          span(:title="$t('ui.action_date')") {{ $t('ui.action_date') }}
                          .float-right
                            i(:class="changeSortKey('action_date')")
                    tbody.clusterize-content
                      tr(v-if="logList.length == 0")
                        td(:colspan="10").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in logList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td.text-left
                          span(:title="item.account_id") {{ item.account_id }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.balance_before)" :title="$n(item.balance_before, 'currency')") {{ $n(item.balance_before, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.amount)" :title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.balance_after)" :title="$n(item.balance_after, 'currency')") {{ $n(item.balance_after, 'currency') }}
                        td
                          span(:title="item.remark") {{ item.remark }} &nbsp;
                        td.text-center
                          span(:title="item.action_type") {{ item.action_type }}
                        td.text-center
                          span(:title="item.action_by") {{ item.action_by }}
                        td.text-right
                          span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
    components: {
        SubmitButton,
        DebounceInput,
        DateRangePicker,
    },
    data: () => ({
        loading: false,
        dateRange: {
            startDate: null,
            endDate: null,
        },
        account_id: "",
        searchOperatorID: "",
        searchMemberID: "",
        feedback: {
            success: false,
            status: errorTags.request.failed
        },
        logList: [],
        currentPage: 1,
        totalRow: 0,
        sortKey: "account_id",
        sortType: "desc"
    }),
    computed: {
        getPageSize() {
            return this.$store.getters.pageSize;
        },
        accountType() {
            return this.$store.getters.accountType;
        },
        isAdmin() {
            return this.$store.getters.accountType === 5;
        },
        isAdminMaster() {
            return [3, 5].includes(this.$store.getters.accountType);
        },
        isOperator() {
            return [2].includes(this.$store.getters.accountType);
        },
        isEditAccess() {
            return this.$helpers.showActionButton("e_resultchangeslog");
        },
        accountID() {
            return this.$store.getters.accountId;
        },
    },
    mounted: function () {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        if (this.isOperator) {
            this.searchOperatorID = this.accountID
            this.getLogList(true);
        }
    },
    methods: {
        sortOrder(key, type) {
            if (this.sortKey == key)
                this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
            else {
                this.sortKey = key;
                this.sortType = 'asc';
            }
            this.getLogList(true);
        },
        changeSortKey(key, type) {
            if (this.sortKey != key)
                return 'fas fa-sort';
            else if (this.sortKey == key && this.sortType == 'asc')
                return 'fa fa-sort-up';
            else if (this.sortKey == key && this.sortType == 'desc')
                return 'fa fa-sort-down';
        },
        checkDateRange() {
            if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
                return false;
            else
                return true;
        },
        getData(currentValue) {
            this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
            this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
            this.getLogList(true);
        },
        getLogList: function (isSearch) {
            if (this.checkDateRange()) {
                let url = config.memberTokenLogUrl();

                if (isSearch) this.currentPage = 1;

                var json = {
                    action_by: this.$store.getters.loginId,
                    auth_token: this.$store.getters.sessionToken,
                    start_date: this.dateRange.startDate,
                    end_date: this.dateRange.endDate,
                    operator_id: this.searchOperatorID,
                    sort_key: this.sortKey,
                    sort_type: this.sortType,
                    page_number: this.currentPage,
                    page_size: this.getPageSize
                };

                if (this.searchMemberID.trim() != '')
                    json.member_id = this.searchMemberID;

                this.loading = true;
                this.$http.post(url, json).then(
                    function (response) {
                        this.loading = false;
                        // Success
                        try {
                            if (response) {
                                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                                this.feedback.status = response.data.statusdesc;
                                if (this.feedback.success == true) {
                                    this.logList = response.data.dt;
                                    this.totalRow = this.logList.length > 0 ? this.logList[0].totalrows : 0;
                                } else {
                                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                                }
                            }
                        } catch (error) {
                            this.feedback.success = false;
                            this.feedback.status = errorTags.request.failed;
                            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                        }
                    },
                    function (response) {
                        this.loading = false;
                        this.feedback.success = false;
                        this.feedback.status = errorTags.request.failed;
                        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                    }
                );
            }
            else {
                this.totalRow = 0;
                this.logList = [];
                this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
            }
        },
        changedPageSize: function (pageSize) {
            this.$store.dispatch("layout/setPageSize", pageSize);
            this.currentPage = 1;
            this.getLogList(true);
        },
        changedPage: function (pageNo) {
            this.currentPage = pageNo;
            this.getLogList();
        },
        handleFailed: function (tag, status) {
            this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
        }
    }
};
</script>
